import axios from 'axios';
import { fetchTokenQuery, logout } from '@/queries/user.query';
import { queryClient } from '@/queries/queryClient';

const hubApi = axios.create({
  baseURL: import.meta.env.VITE_MESSAGE_HUB_URL,
});

hubApi.interceptors.request.use(
  async (config) => {
    const tokenObject = await fetchTokenQuery();
    if (tokenObject) {
      config.headers["Authorization"] = `Bearer ${tokenObject.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

hubApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized, logging out ...");
      logout();
      queryClient.clear();
    }
    throw error;
  }
);

export { hubApi };
